// src/data/releaseNotesContent.js
// Release notes content embedded directly to avoid static file serving issues

export const releaseNotesContent = {
  'v251217x': `
    <div class="container">
      <div class="header">
        <h1><i class="fas fa-filter"></i> Site Filter & Toegangsbeheer</h1>
        <p>Snel wisselen tussen locaties met de nieuwe Site Switcher</p>
        <div class="version-badge">Release v251217x - December 17, 2025</div>
      </div>
      <div class="content">
        <p><strong>Release Date:</strong> December 17, 2025<br>
        <strong>Type:</strong> Feature Release<br>
        <strong>Impact:</strong> Nieuwe functionaliteit voor site filtering en toegangsbeheer</p>

        <div class="highlight-box new">
          <strong><i class="fas fa-sparkles"></i> Nieuwe Functie: Site Switcher</strong>
          <p>Met de nieuwe Site Switcher kunt u snel filteren op specifieke locaties. Selecteer een site in de navigatiebalk en alle pagina's tonen automatisch alleen data van die locatie!</p>
        </div>

        <h2><i class="fas fa-filter"></i> Site Switcher</h2>
        <p>De Site Switcher is een nieuw filter in de navigatiebalk waarmee u snel kunt wisselen tussen locaties:</p>

        <h3>Hoe werkt het?</h3>
        <ul class="feature-list">
          <li class="filter"><strong>Locatie in navigatiebalk:</strong> De Site Switcher bevindt zich rechts in de navigatiebalk, naast uw gebruikersnaam</li>
          <li class="building"><strong>Site selecteren:</strong> Klik op de selector en kies een site uit de lijst</li>
          <li class="check"><strong>Automatische filtering:</strong> Alle pagina's filteren automatisch op de geselecteerde site</li>
          <li class="star"><strong>Sessie onthouden:</strong> Uw selectie blijft behouden tijdens uw sessie</li>
        </ul>

        <h3>Gefilterde Pagina's</h3>
        <p>De Site Switcher filtert automatisch de volgende pagina's:</p>
        <ul class="feature-list">
          <li class="check"><strong>Locatiebeheer:</strong> Zie alleen locaties binnen de geselecteerde site</li>
          <li class="check"><strong>Tickets:</strong> Bekijk alleen tickets van een specifieke site</li>
          <li class="check"><strong>Alarmen:</strong> Focus op alarmen van een bepaalde locatie</li>
        </ul>

        <h2><i class="fas fa-user-shield"></i> Site Toegangsbeheer</h2>
        <p>Beheerders kunnen nu gebruikers toegang geven tot specifieke sites:</p>
        <ul class="feature-list">
          <li class="star"><strong>Gebruikersbeheer > Location Access tab:</strong> Wijs sites toe aan gebruikers</li>
          <li class="star"><strong>Granulaire toegang:</strong> Bepaal precies welke sites een gebruiker mag zien</li>
          <li class="star"><strong>Automatische filtering:</strong> Gebruikers zien alleen data van hun toegewezen sites</li>
        </ul>

        <div class="highlight-box info">
          <strong><i class="fas fa-info-circle"></i> Hoe werkt toegangsbeheer?</strong>
          <p>Ga naar <strong>Gebruikersbeheer</strong>, selecteer een gebruiker, en klik op de <strong>Location Access</strong> tab. Hier kunt u sites toevoegen of verwijderen waartoe de gebruiker toegang heeft.</p>
        </div>

        <div class="highlight-box success">
          <strong><i class="fas fa-check-circle"></i> Samenvatting</strong>
          <p>Met de nieuwe Site Switcher navigeert u sneller door CARO door te filteren op specifieke locaties. Beheerders kunnen nu ook granulaire toegangsrechten toekennen aan gebruikers op site-niveau.</p>
        </div>
      </div>
      <div class="footer">
        <p><strong>CARO Management Portal</strong></p>
        <p>© 2025 CARO Technologies | Release v251217x</p>
      </div>
    </div>
  `,

  'v20251107a': `
    <div class="container">
      <div class="header">
        <h1><i class="fas fa-paint-brush"></i> UX Overhaul</h1>
        <p>Volledige herwerking van de gebruikerservaring</p>
        <div class="version-badge">Release v251107a - November 7, 2025</div>
      </div>
      <div class="content">
        <div class="highlight-box new">
          <strong><i class="fas fa-bolt"></i> Performance & UX Verbeteringen</strong>
          <p>Snellere laadtijden en verbeterde gebruikerservaring met skeleton loaders en geoptimaliseerde code.</p>
        </div>
        <ul class="feature-list">
          <li class="check"><strong>Snellere laadtijden:</strong> Geoptimaliseerde code en assets</li>
          <li class="check"><strong>Skeleton Loaders:</strong> Vloeiendere contentweergave tijdens laden</li>
        </ul>
      </div>
      <div class="footer">
        <p><strong>CARO Management Portal</strong></p>
        <p>© 2025 CARO Technologies</p>
      </div>
    </div>
  `,

  'v2510028a': `
    <div class="container">
      <div class="header">
        <h1><i class="fas fa-camera"></i> Camera Requests & Improvements</h1>
        <p>Camera beelden aanvragen en algemene verbeteringen</p>
        <div class="version-badge">Release v2510028a - October 28, 2025</div>
      </div>
      <div class="content">
        <ul class="feature-list">
          <li class="wrench"><strong>Bug fixes:</strong> Performance improvements</li>
          <li class="check"><strong>Camera Footage Requests:</strong> Vraag eenvoudig camerabeelden aan via CARO</li>
          <li class="check"><strong>Interventieverslagen:</strong> Bij fysieke interventies</li>
          <li class="check"><strong>Verbeterde zoekfunctie:</strong> Tickets en locaties vinden</li>
        </ul>
      </div>
      <div class="footer">
        <p><strong>CARO Management Portal</strong></p>
        <p>© 2025 CARO Technologies</p>
      </div>
    </div>
  `,

  'v251007a': `
    <div class="container">
      <div class="header">
        <h1><i class="fas fa-search"></i> Enhanced Search & Animations</h1>
        <p>Verbeterde zoekfunctionaliteit en dynamische animaties</p>
        <div class="version-badge">Release v251007a - October 7, 2025</div>
      </div>
      <div class="content">
        <ul class="feature-list">
          <li class="check"><strong>Fuzzy Search:</strong> Vind sneller wat je zoekt</li>
          <li class="check"><strong>Dynamische Animaties:</strong> Verbeterde gebruikerservaring</li>
          <li class="check"><strong>Snellere laadtijden:</strong> Responsieve interface</li>
        </ul>
      </div>
      <div class="footer">
        <p><strong>CARO Management Portal</strong></p>
        <p>© 2025 CARO Technologies</p>
      </div>
    </div>
  `,

  'v251006c': `
    <div class="container">
      <div class="header">
        <h1><i class="fas fa-globe"></i> Multi-Language Support</h1>
        <p>CARO spreekt nu jouw taal!</p>
        <div class="version-badge">Release v251006c - October 6, 2025</div>
      </div>
      <div class="content">
        <div class="highlight-box new">
          <strong><i class="fas fa-language"></i> Meertalige ondersteuning</strong>
          <p>Volledige meertalige ondersteuning met real-time taal switching.</p>
        </div>
        <ul class="feature-list">
          <li class="check"><strong>Nederlands, English, Français, Deutsch</strong></li>
          <li class="check"><strong>West-Vlaams en Antwerps:</strong> Dialecten toegevoegd</li>
          <li class="check"><strong>Real-time switching:</strong> Zonder pagina herlaad</li>
          <li class="check"><strong>Localized formats:</strong> Datum en tijd per regio</li>
        </ul>
        <div class="highlight-box info">
          <strong>Hoe wijzigen?</strong>
          <p>Ga naar <strong>Instellingen > Taal & Regio</strong> om te wijzigen.</p>
        </div>
      </div>
      <div class="footer">
        <p><strong>CARO Management Portal</strong></p>
        <p>© 2025 CARO Technologies</p>
      </div>
    </div>
  `,

  'v251006b': `
    <div class="container">
      <div class="header">
        <h1><i class="fas fa-mobile-alt"></i> Mobile & Tablet Overhaul</h1>
        <p>Volledige herwerking mobiele ervaring</p>
        <div class="version-badge">Release v251006b - October 6, 2025</div>
      </div>
      <div class="content">
        <ul class="feature-list">
          <li class="check"><strong>Geen horizontaal scrollen meer!</strong></li>
          <li class="check"><strong>Quick Actions Dashboard:</strong> Snelle toegang tot functies</li>
          <li class="check"><strong>Tabellen → Kaarten:</strong> Op mobiel voor betere leesbaarheid</li>
          <li class="check"><strong>Touch-geoptimaliseerd:</strong> Knoppen en interface</li>
          <li class="check"><strong>Volledige schermweergave:</strong> Pop-ups op mobiel</li>
          <li class="check"><strong>Getest op alle apparaten:</strong> iPhone, Android, iPad, tablets</li>
        </ul>
      </div>
      <div class="footer">
        <p><strong>CARO Management Portal</strong></p>
        <p>© 2025 CARO Technologies</p>
      </div>
    </div>
  `,

  'v251003': `
    <div class="container">
      <div class="header">
        <h1><i class="fas fa-rocket"></i> Initial Release</h1>
        <p>Complete Portal System</p>
        <div class="version-badge">Release v2.1.0 (v251003) - October 3, 2025</div>
      </div>
      <div class="content">
        <div class="highlight-box new">
          <strong><i class="fas fa-star"></i> Eerste versie CARO Management Portal</strong>
          <p>Volledige ticketing, locatie- en apparaatbeheer.</p>
        </div>
        <ul class="feature-list">
          <li class="check"><strong>Live ticketing systeem:</strong> Meld problemen en volg de status</li>
          <li class="check"><strong>Real-time dashboard:</strong> Met statistieken</li>
          <li class="check"><strong>Locatiebeheer:</strong> Hiërarchische structuur</li>
          <li class="check"><strong>Apparaatbeheer:</strong> Online/offline status</li>
          <li class="check"><strong>PWA:</strong> Installeer als desktop/mobiele app</li>
          <li class="check"><strong>Microsoft SSO:</strong> Met Multi-Factor Authenticatie</li>
          <li class="check"><strong>Uitgebreide instellingen:</strong> Thema's, lettertypen, toegankelijkheid</li>
          <li class="check"><strong>Gebruikersbeheer:</strong> Rol- en permissie systeem</li>
          <li class="check"><strong>Multi-tenant:</strong> Architectuur per bedrijf</li>
          <li class="check"><strong>E-mail notificaties:</strong> Voor ticket updates</li>
        </ul>
      </div>
      <div class="footer">
        <p><strong>CARO Management Portal</strong></p>
        <p>© 2025 CARO Technologies</p>
      </div>
    </div>
  `
};
